<template>
	<div class="container" @touchmove.prevent>
		<!--页面开始-->
		<div class="countdown">
			<div class="top_tips" @click="exit">
				<van-button
					plain
					hairline
					size="small"
					round
					color="#5449f2"
					type="info"
				>
					Saltar
				</van-button>
			</div>
		</div>
		<div v-if="isOnceShow" class="count_box" :class=" type === 1 ? 'spec_pad_top' : '' ">
			<div class="father">
				<div class="sonBox" :class="type === 1 ? 'sonBox_60' : 'sonBox_600'">
					<div class="son"></div>
				</div>
			</div>
			<div class="box">
			    <div class="left_box">
					<div class="left_item" :class="type === 1 ? 'left_item_60' : 'left_item_600'"></div>
			    </div>
			    <div class="right_box">
					<div class="right_item" :class="type === 1 ? 'right_item_60' : 'right_item_600'"></div>
			    </div>
			    <div class="mask"></div>
			</div>
			<!-- <van-circle
			  v-model="currentRate"
			  :color="gradientColor"
			  :rate="cir_num"
			  size="7rem"
			  stroke-width="30"
			  layer-color="#daedff"
			  :clockwise="false"
			> -->
				<div class="cir_box">
					<div class="img_box">
						<img src="../../assets/img/circle_bg.webp" />
					</div>
					<div class="tit_box">
						<div class="time">
							<van-count-down
								:time="countTime"
								format="mm:ss"
								@finish="timeOver"
								@change="timeChange"
								:auto-start="countStart"
								/>
						</div>
						<div class="tit">Espera</div>
					</div>
				</div>
			<!-- </van-circle> -->
		</div>
		<div v-if="type === 10" class="bot_box">
			<van-image
			  width="100%"
			  height="auto"
			  lazy-load
			  show-loading
			  :src="require('@/assets/img/spain/count_down_10.webp')"
			>
				<template v-slot:loading>
					<div class="wrap color-A">
						<div class="k-line k-lineA-1"></div>
						<div class="k-line k-lineA-2"></div>
						<div class="k-line k-lineA-3"></div>
						<div class="k-line k-lineA-4"></div>
					</div>
				</template>
			</van-image>
		</div>
		<!--页面开始-->
	</div>
</template>

<script>
export default {
	components:{
		//
	},
	data() {
		return {
			type: null,
			/* currentRate: 100,
			cir_num: 100,
		    gradientColor: {
				'0%': '#a74af2',
				'100%': '#5949f2',
		    }, */
			countTime: 0,  //倒计时时间
			noSleep: null,  //屏幕常亮对象
			countStart: false,  //首次加载倒计时
			cir_tip_10: '',  //10分钟倒计时默认不动
			cir_left_10: '',  //10分钟倒计时默认不动
			cir_right_10: '',  //10分钟倒计时默认不动
			noTouch: false,
			isOnceShow: false,
		}
	},
	created(){
		let that = this;
		sessionStorage.clear();
		this.$toast.loading({
			duration: 0,
		});
		if(this.$route.query.type === '10'){
			this.type = 10;
			this.initTime(10 * 60 * 1000);  //初始化倒计时
			sessionStorage.setItem('countDown', 'true');
		}else{
			this.$router.replace({path:'/spain/stepOne'});
		}
	},
	mounted() {
		let that = this;
		that.$toast.clear();
		that.$nextTick(() => {
			that.isOnceShow = true;
		});
	},
	watch: {
		
	},
	methods: {
		initTime(value) {
			this.countTime = value;
			this.countStart = true;
		},
		//退出检测程序
		exit() {
			let that = this;
			let text = '';
			//区别1、10分钟
			if(that.type === 10){
				text = '¿Está seguro? El resultado incorrecto puede ocurrir si la solución se dispensa en el orificio de muestra durante menos de 10 minutos.';
			}
			that.$dialog.confirm({
			  title: 'Confirmar',
			  message: text,
			  confirmButtonText: 'Cancelar',
			  cancelButtonText: 'Sí',
			  confirmButtonColor: '#333333',
			}).then(() => {
				//点击关闭
			}).catch(() => {
			    //点击确定
				if(that.type === 10){
					that.$router.replace({path: '/spain/stepSeven'});
				}
			});
		},
		//倒计时变化
		timeChange(timeData) {
			//console.log(timeData);
		},
		//倒计时结束
		timeOver() {
			let that = this;
			//计时结束关闭弹框
			that.$dialog.close();
			if(that.type === 10){
				that.$router.replace({path: '/spain/stepSeven'});
			}
		},
	},
	destroyed() {
		//注销屏幕常亮
		/* if(this.noSleep){
			this.noSleep.disable();
		} */
	}
}
</script>
</script>

<style scoped>
.top_tips{position: absolute;top: 0;padding:0.5rem 0 0 0.45rem;color: #333333;font-weight: bold;display:inline-block;}
>>> .top_tips .van-button--small{
	height: 28px;
	padding: 0 10px;
}
.count_box{
	padding-top: 1.973rem;
	text-align: center;
	display: flex;
	justify-content: center;
}
.spec_pad_top{
	padding-top: 3.2rem;
}
.cir_box{
	position: absolute;
}
.cir_box .img_box{
	width: 260px;
	height: 260px;
	position: absolute;
	left: 0;
	right: 0;
	top: 5.5px;
	bottom: 0;
	margin: 0 auto;
	z-index: 2;
}
.cir_box .img_box img{
	width: 100%;
	height: 100%;
}
.tit_box{
	position: relative;
	width: 273px;
	top: 95px;
	z-index: 3;
}
.tit_box .time .van-count-down{
	font-size: 60px;
	line-height: 60px;
	font-weight: bold;
	color: #5949f2;
}
.number{
	font-size: 60px;
	line-height: 60px;
	font-weight: bold;
	color: #5949f2;
}
.tit_box .tit{
	margin-top: 10px;
	color: #5949f2;
	font-weight: bold;
}


.bot_box{
	padding: 1.173rem 0.827rem 1rem 0.827rem;
}
.bot_box .bot_tit{
	color: #720000;
	font-size: 0.427rem;
	font-weight: bold;
}
.bot_box .bot_txt{
	padding-top: 0.4rem;
	color: #333333;
}

.null_box{
	width: 273px;
	height: 273px;
}

/*进度点*/
@keyframes spin{
	to{
		transform:rotate(1turn);
	}
}
@keyframes spin-reverse{
	from{
		transform:rotate(1turn);
	}
}
.father{
	width: 273px;
	height: 273px;
	border-radius:50%;
    position: absolute;
    z-index: 99;
}
.son{ 
	width: 15px;
	height: 15px;
	margin: -3px auto 0;
  background:linear-gradient(to left bottom, #5949f2, #a74af2);
  box-shadow: 0 0 15rpx #a74af2;
  border-radius: 50%;
}

/*圆环*/
.box{
  width:270px;
  height:270px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  border-radius: 50%;      
  background-color: #daedff;
}
.left_box,.right_box{
  position: absolute;
  top: 0;
  width:135px;
  height:270px;
  overflow: hidden;
  z-index: 1;
}
.left_box{
  left: 1px;
}
.right_box{
  right: 0;
}
.left_item,.right_item{
  width: 135px;
  height: 270px;
}
.left_item{
  border-top-left-radius: 135px;
  border-bottom-left-radius: 135px;
  background-color: #a74af2;
}
.right_item{
  border-top-right-radius: 135px;
  border-bottom-right-radius: 135px;
  background-color: #a74af2;
}
.mask{
  /* 遮住div多余的部分，呈现出线条的效果 */
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  bottom: 10px;
  z-index: 2;
  border-radius: 50%;
  background-color: #fff;
}
@-webkit-keyframes loading_left{
	0%{
		-webkit-transform: rotate(0deg);
	}
	50%{
		-webkit-transform: rotate(0deg);
	}
	100%{
		-webkit-transform: rotate(180deg);
	}
}
@-webkit-keyframes loading_right{
	0%{
	  -webkit-transform: rotate(0deg);
	}
	50%{
	  -webkit-transform: rotate(180deg);
	}
	100%{
	  -webkit-transform: rotate(180deg);
	}
}



/*统一控制圆环*/
.sonBox_60{
  animation: spin 59s infinite linear;
  animation-iteration-count: 1;
  transform-origin:50% 139px;
}
.sonBox_600{
  animation: spin 604s infinite linear;
  animation-iteration-count: 1;
  transform-origin:50% 138px;
}
.left_item_60{
  -webkit-transform-origin: right center;
  transform-origin: right center;
  -webkit-animation: loading_left 59s linear;
  animation-fill-mode:forwards;
}
.left_item_600{
  -webkit-transform-origin: right center;
  transform-origin: right center;
  -webkit-animation: loading_left 604s linear;
  animation-fill-mode:forwards;
}
.right_item_60{
  -webkit-transform-origin: left center;
  transform-origin: left center;
  -webkit-animation: loading_right 59s linear;
  animation-fill-mode:forwards;
}
.right_item_600{
  -webkit-transform-origin: left center;
  transform-origin: left center;
  -webkit-animation: loading_right 604s linear;
  animation-fill-mode:forwards;
}
@media only screen 
and (device-width : 375px) 
and (device-height : 667px) 
and (-webkit-device-pixel-ratio : 2) {
	.count_box{
		padding-top: 1.6rem;
	}
    .bot_box{
		padding-top:0.6rem;
	}
}
</style>
